import Button from "../bootstrap/Button";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../bootstrap/Modal";
import Spinner from "../bootstrap/Spinner";

interface Props {
    isModalOpened: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    isSubmitting?: boolean;
    onConfirm: () => void;
    onModalClose: () => void;
}

export const ConfirmationModal = ({ isModalOpened
    , title
    , message
    , confirmText
    , cancelText
    , isSubmitting
    , onConfirm
    , onModalClose}: Props) => {

    const onClose = () => {
        onModalClose();
    };

    return (
        <Modal isOpen={isModalOpened} setIsOpen={onClose} isCentered isStaticBackdrop>
            <ModalHeader setIsOpen={onClose}>
                <ModalTitle id="confirmation-modal-title">{title || 'Confirmar ação'}</ModalTitle>
            </ModalHeader>

            <ModalBody>
                <div className="py-3 px-2">
                    <p className="fs-5">{message || 'Deseja confirmar a ação?'}</p>
                </div>
            </ModalBody>

            <ModalFooter className="bg-transparent d-flex justify-content-end gap-2">
                <Button                                                 
                    color="info"
                    isOutline={true} 
                    onClick={onClose}
                >
                    {cancelText || 'Cancelar'}
                </Button>
                <Button 
                    color="primary" 
                    onClick={onConfirm} 
                    isDisable={isSubmitting}
                >
                        {isSubmitting && <Spinner isSmall inButton isGrow />}
                        {confirmText || 'Confirmar'}
                </Button>
            </ModalFooter>
        </Modal>
    );

}